// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PtoLayoutSquareOutlinedSvg from "@fishx/icons-svg/es/asn/PtoLayoutSquareOutlined";
import FishxIcon from '../components/FishxIcon';

var PtoLayoutSquareOutlined = function PtoLayoutSquareOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PtoLayoutSquareOutlinedSvg
  }));
};

PtoLayoutSquareOutlined.displayName = 'PtoLayoutSquareOutlined';
export default React.forwardRef(PtoLayoutSquareOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PtoLayoutSquareOutlined.js
// module id = 3912
// module chunks = 0